module.exports = __webpack_public_path__ + "static/media/mashing-banner.42e9fc36.webp";